import React, { useState } from "react";

import axios from "axios";
import "./ShareCardModal.css"; // קובץ סגנון נפרד אם תרצי

export default function ShareCardModal({ isOpen, onClose }) {
  const [share, setShare] = useState(false);
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PShareCard",
        {
          note: note,
        },
        config
      );

      if (response.status === 200) {
        alert("תודה! ההעדפה נשמרה בהצלחה.");
        onClose();
      } else {
        alert("שגיאה בשמירה, נסה שוב מאוחר יותר.");
      }
    } catch (err) {
      console.error(err);
      alert("שגיאה בחיבור לשרת.");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>שיתוף הכרטיס שלי בסטטוס של דאבל</h3>

        <p>
          בסימון "כן" אני מבקש/ת מדאבל לשתף את הכרטיס שלי בסטטוס וערוצי המדיה של
          דאבל 💫
        </p>
        <div className="note-cellular"></div>
        <small>
          משתפים רק כרטיס שמופיע בו מספר טלפון של חבר/ה לבירורים, כדי שיוכלו
          ליצור איתכם קשר דרך אותו איש קשר — ולא ישירות אליכם. נא לבדוק שהפרופיל
          שלכם מעודכן עם מספר טלפון נכון לפני השיתוף.{" "}
        </small>
        <div
          className="mainButton"
          style={{
            textDecoration: "none",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <a href="/myProfile" target="_blank" rel="noopener noreferrer">
            איך הפרופיל שלי נראה?{" "}
          </a>
        </div>

        <div className="checkbox-row">
          <input
            type="checkbox"
            checked={share}
            onChange={(e) => setShare(e.target.checked)}
          />
          <label>אני מאשר/ת לשתף את הפרופיל שלי בסטטוסים של דאבל</label>
        </div>

        <textarea
          className="freetext"
          style={{ height: "50px" }}
          placeholder="רוצה להוסיף הערה או בקשה? (לא חובה)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <div className="buttons">
          <button onClick={onClose}>ביטול</button>
          <button
            style={{ background: isLoading ? "#ccc" : "var(--btn-home-color)" }}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "שומר..." : "שמירה"}
          </button>
        </div>
      </div>
    </div>
  );
}
